import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-info-e-coupon',
  templateUrl: './info-e-coupon.component.html',
  styleUrls: ['./info-e-coupon.component.scss']
})
export class InfoECouponComponent implements OnInit {
  pcForm!: FormGroup;
  coupons: any[] = [];
  @Output() dataChange = new EventEmitter<any>();
  @Output() disable = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.getCoupon();
    this.initializeForm();
    
    // Subscribe to form changes
    this.pcForm.valueChanges.subscribe((formData) => {
      // console.log('valueChanges',formData);

      let batchCodePass = false;
      if(formData.couponBatchCode) {
        if(formData.batchCode.length == formData.bc.length) {
          batchCodePass = true;
        }
      }

      var result = {
        coupon: formData.coupon,
        couponBatchCode: formData.couponBatchCode,
        assistantPc: formData.assistantPc,
        batchCodePass: batchCodePass,
        batchCode: formData.batchCode,
        imageUrl: formData.imageUrl
      };
      // console.log('result coupon :: ',result);
      this.dataChange.emit(result);
      this.disable.emit(this.checkDisable());
    });
  }

  initializeForm(): void {
    this.pcForm = this.fb.group({
      coupon: ['', [Validators.required]],
      couponBatchCode: [false],
      assistantPc: ['', [Validators.required]],
      batchCode: [''],
      bc: [''],
      imageUrl: [null],
    });
  }
  
  get f() {
    return this.pcForm.controls;
  }

  async getCoupon() {
    this.userService.getCoupons({}).subscribe({
      next: (res) => {
        this.coupons = res;
      },
      error: (error) => null,
    });
  }

  changeCoupon(event: any) {
    console.log(event.target.value);
    var batch = this.coupons.find((c: any) => c.id == event.target.value).couponAndClinics[0].batchCode;
    if (batch) {
      this.pcForm.get('batchCode')?.setValidators([Validators.required]);
      this.pcForm.get('imageUrl')?.setValidators([Validators.required]);
    } else {
      this.pcForm.get('batchCode')?.clearValidators();
      this.pcForm.get('imageUrl')?.clearValidators();
    }
    this.pcForm.get('batchCode')?.updateValueAndValidity();
    this.pcForm.get('imageUrl')?.updateValueAndValidity();
    this.pcForm.patchValue({
      couponBatchCode: batch != '' ? true : false,
      bc: batch,
    });
    // this.updateValidateFormFile(batch != '' ? true : false);
  }

  // Handle the emitted image file from the child component
  onImageSelected(image: String): void {
    // this.articleForm.get('image')?.setValue(file);
    this.f['imageUrl'].setValue(image);
  }

  checkDisable() {
    if (this.pcForm.valid) {
      return false;
    } else {
      return true;
    }
  }
}
